import { Link, useLocation } from "react-router-dom";
import { RightArrowIcon } from "./RightArrow";

const ParallaxTwoColumn = ({ data }: any) => {
  const { pathname } = useLocation();

  return (
    <section
      className="video__area"
      style={{ padding: pathname === "/" ? "" : "80px 50px" }}
    >
      <div
        className="video__bg"
        // data-background={"assets/img/bg/h4_video_bg.jpg"}
        style={{ backgroundImage: `url("assets/img/bg/h4_video_bg.jpg")` }}
      ></div>
      <div className={`container ${pathname === "/" ? "px-3" : ""}`}>
        <div className="row align-items-center">
          <div className="col-xl-8 col-lg-6 col-12">
            <div className="video__content mt-10">
              <h2 className="title">
                {data?.title || "Bridging the Gap, Empowering the Future"}
              </h2>
              <p style={{ fontSize: 22 }}>
                {data?.subTitle || "Where curiosity meets impact"}
              </p>
              <Link
                to="assets/img/index/MESC-Brochure-2024-25.pdf"
                target="_blank"
                className="btn btn-three arrow-btn"
              >
                MESC Brochure
                {/* <img
                  src={"/assets/img/icons/right_arrow.svg"}
                  alt=""
                  className="injectable"
                  width={16}
                  height={14}
                /> */}
                <RightArrowIcon />
              </Link>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 order-0 order-lg-2">
            <div className="video__play-btn">
              <a href={data?.videoLink} target="_blank" rel="noreferrer">
                <i className="fas fa-play"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ParallaxTwoColumn;
